import { Reveal, Eyebrow } from "./Reveal";
import { manifesto, profile } from "../../data/resume";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="mx-auto max-w-[1400px] px-6 sm:px-12 lg:px-20 py-24 lg:py-36"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
        <div className="lg:col-span-4">
          <Reveal>
            <Eyebrow>(About)</Eyebrow>
            <h2 className="mt-6 font-serif font-normal text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-ink">
              Building products people actually use.
            </h2>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:col-start-6">
          <Reveal delay={0.1}>
            <p className="font-serif italic text-2xl sm:text-3xl leading-snug text-inksoft">
              I turn customer research into product decisions — {profile.yearsExperience} years across
              AI and SaaS, from discovery and roadmap to launch.
            </p>
          </Reveal>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-8">
            {manifesto.map((m, i) => (
              <Reveal key={m.no} delay={0.1 + i * 0.12}>
                <div className="border-t border-ink pt-5">
                  <span className="font-mono text-sm text-rust">{m.no}</span>
                  <h3 className="mt-3 font-serif text-2xl text-ink">{m.title}</h3>
                  <p className="mt-3 font-sans text-sm leading-relaxed text-inksoft">
                    {m.body}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
